import AdminSidebar from "@/components/AdminSidebar";

export default function AdminLayout({ children }) {
  return (
    <div className="min-h-screen" style={{ background: "var(--mv-bg)" }}>
      <AdminSidebar />
      <div className="min-w-0" style={{ marginLeft: 240 }}>{children}</div>
    </div>
  );
}
